import React from 'react';

const ButtonFlat = ({ children, size = 'md', onClick = () => {}, disabled = false }) => (
    <button
        className={`appButton__flat ${size}`}
        disabled={disabled}
        onClick={onClick}>
        {children}
    </button>
);

export default ButtonFlat;